// extracted by mini-css-extract-plugin
module.exports = {"snackbarMessage":"showRefreshSnackbar_snackbarMessage__Tn5lU"};